import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { Image } from "react-native";
import { useFragment } from "react-relay";

import { getThumbnail } from "@whoosh/utilities/src/Cloudinary";

import { ClubLogoFragment_UnauthenticatedClub$key } from "./__generated__/ClubLogoFragment_UnauthenticatedClub.graphql";

export const ClubLogo = ({
  clubRef,
}: {
  clubRef: ClubLogoFragment_UnauthenticatedClub$key;
}) => {
  const club = useFragment(ClubLogoFragmentString, clubRef);
  const clubLogoPublicId = club.logoImage?.publicId;

  return (
    <Image
      source={{
        uri: getThumbnail(clubLogoPublicId, 55, 55)?.toURL(),
      }}
      accessibilityLabel={t`Club Logo`}
      style={{
        width: 40,
        height: 40,
        borderRadius: 6,
      }}
    />
  );
};

export const ClubLogoFragmentString = graphql`
  fragment ClubLogoFragment_UnauthenticatedClub on UnauthenticatedClub {
    slug
    logoImage {
      # TODO(ENG-3436): Remove the publicId alias when legacy image props are retired.
      publicId: renderingKey
    }
  }
`;
